module.exports = __webpack_public_path__ + "static/media/tick.2d5a30f5.svg";